@let dataCyButtonId = `${tableId()}_setting_cell_button_${index() + 1}`;
<button
  mat-button
  type="button"
  [attr.data-cy]="dataCyButtonId"
  [disabled]="disabled()"
  [matMenuTriggerFor]="menu"
>
  <mat-icon class="!m-auto" customMatSvgIcon="pct-mdi-dots-horizontal" />
</button>

<mat-menu #menu="matMenu">
  @let row = rowItem();
  <!--  @todo: find a better solution then use label az tracker-->
  @for (menuItem of menuItems(); track menuItem.label) {
    @if (menuItem.show) {
      <button
        mat-menu-item
        type="button"
        [attr.data-cy]="`${dataCyButtonId}_menu_item_${$index + 1}`"
        [disabled]="menuItem.disabled"
        (click)="menuItem.action(row)"
      >
        {{ menuItem.label | resolveTranslateAbleText }}
      </button>
    }
  }
</mat-menu>
